export default "__VITE_ASSET__YSaiWOXw__"